import React from 'react';

const KhulegLogo = ({ style = {}, ...props }) => (
  <img
    src={process.env.PUBLIC_URL + '/khuleg-logo.png'}
    alt="Khuleg Subaru Auto Service Logo"
    style={{ width: 60, height: 60, objectFit: 'contain', ...style }}
    {...props}
  />
);

export default KhulegLogo;
